import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosAPI from "app/config/axiosAPI";

export const getAllCalendars = createAsyncThunk("getAllCalendars", async (id) => {
  try {
    const res = await axiosAPI.get(`/linkedaccount/${id}`);
    return res.data;
  } catch (err) {
    return err.res.data;
  }
});

export const unlinkCalendar = createAsyncThunk("unlinkCalendar", async (id) => {
  try {
    const res = await axiosAPI.delete(`/studio/${id}/calendar`);
    return res.data.id;
  } catch (err) {
    return err.res.data;
  }
});

export const initialState = {
  data: [],
  isLoading: false,
  isError: false
}

export const calendarsSlice = createSlice({
  name: 'calendars',
  initialState,
  reducers: { },
  extraReducers: (builder) => {
    builder.addCase(getAllCalendars.pending, (state) => {
      state.isLoading = true;
    })
    builder.addCase(getAllCalendars.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
    })
    builder.addCase(getAllCalendars.rejected, (state) => {
      state.isLoading = false;
      state.isError = false;
    })
    builder.addCase(unlinkCalendar.pending, (state) => {
      state.isLoading = true;
    })
    builder.addCase(unlinkCalendar.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: state.data.filter(item => item.id !== payload),
        isLoading: false
      };
    })
    builder.addCase(unlinkCalendar.rejected, (state) => {
      state.isLoading = false;
      state.isError = false;
    })
  }
})

export const calendarsActions = calendarsSlice.actions

export default calendarsSlice.reducer